import { CCAssessmentType } from "../../Physician/Models/CCEnrollment";


export default class CcAssessmentPathwayEnrollment {
    ccEnrollmentId: number;
    currentBlockStart: string;
    currentBlockEnd: string;
    currentBlockExtensionDate: string;
    oneCertificationAnnualFee: number;
    twoCertificationAnnualFee: number;
    threeOrMoreCertificationAnnualFee: number;
    articlePathwayPerCertificationMinimum: number;

    ccEnrollmentCertificates: Array<CcAssessmentPathwayEnrollmentCertificate>;

    
}

export class CcAssessmentPathwayEnrollmentCertificate{
    cCEnrollmentCertificateId: number;
    certificateId: number;
    certificationName: string;
    certificationGeneration: number;
    expirationDate: string;
    isAbccEligible: boolean;
    isAbccStillAvailable: boolean;
    isEnrolled: boolean;
    isFuture: boolean;
    enrollmentStartDate: string;
    enrollmentEndDate: string;
    ccAssessmentType: CCAssessmentType;
    ccAssessmentAttestationDate: string;
    lastArticleAssessmentEnrolledDate: string;
}

export class CCAssessmentPathwayHelper{
    static getAnnualFee = (pathwayEnrollment: CcAssessmentPathwayEnrollment) : number => {
        var numCertificates = pathwayEnrollment.ccEnrollmentCertificates.filter(_ => _.isEnrolled).length;
        console.log(numCertificates);
        if (numCertificates == 0) return 0;
        if (numCertificates == 1) return pathwayEnrollment.oneCertificationAnnualFee;
        if (numCertificates == 2) return pathwayEnrollment.twoCertificationAnnualFee;
        return pathwayEnrollment.threeOrMoreCertificationAnnualFee;
    }
}
